import {
  getConnectionsList,
  postRemove,
  getConnectionsExportList,
  postupdateAddAllExport,
  postCheckDelete,
  getExportModel
} from "./services";

export async function getConnectionsListAction(/*{ commit }*/) {
  try {
    return (await getConnectionsList()).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getConnectionsExportListAction(/*{ commit }*/) {
  try {
    return (await getConnectionsExportList()).data;
  } catch (e) {
    console.log(e);
  }
}
export async function postupdateAddAllExportAction({ commit }, payload) {
  try {
    return (await postupdateAddAllExport(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function remove({ commit }, payload) {
  try {
    return (await postRemove(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
export async function postCheckDeleteAction({ commit }, payload) {
  try {
    return (await postCheckDelete(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function getExportModelAction({ commit }) {
  try {
    return (await getExportModel()).data;
  } catch (e) {
    console.log(e);
  }
}